/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
//import { KTSVG } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import {LanguageHelp} from '../../../../helpers/LanguageHelper'

const SidebarMenuMain = () => {

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={LanguageHelp("Dashboard")}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub 
        to='/crafted/ai'
        title={LanguageHelp("Artificial Intelligence")}
        icon='/media/icons/duotune/general/gen002.svg'
        fontIcon='bi-ai'
      >
        <SidebarMenuItem to='/apps/artificial-intelligence/overview' title={LanguageHelp('Sentiment Analysis')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/tokens' title={LanguageHelp('Tokens')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/subjects' title={LanguageHelp('Subjects')} hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub 
        to='/crafted/accounts'
        title={LanguageHelp("Settings")}
        icon='/media/icons/duotune/coding/cod001.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/profile' title={LanguageHelp('Profile')} hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/company' title={LanguageHelp('Company')} hasBullet={true} />
        <SidebarMenuItem to='/crafted/channels' title={LanguageHelp('Channels')} hasBullet={true} />
        <SidebarMenuItem to='/apps/user-management/users' title={LanguageHelp('User Management')} hasBullet={true} />
      </SidebarMenuItemWithSub>
    </>
  )
}

export { SidebarMenuMain }
